(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview-simple.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview-simple.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const CardBody = svs.ui.ReactCard.CardBody;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  IconButton = _svs$ui.ReactIconButton,
  Button = _svs$ui.ReactButton;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const _svs$components$casin = svs.components.casino_react.casinoStore.hooks,
  useSearchResults = _svs$components$casin.useSearchResults,
  useFavorites = _svs$components$casin.useFavorites;
const _React = React,
  useState = _React.useState;
const getAnalyticsPosition = svs.components.casino_react.analytics_utils.utils.getAnalyticsPosition;
const dispatchGameToLastSearched = svs.components.casino_react.casinoStore.utils.lastSearched.dispatchGameToLastSearched;
const CardType = svs.components.casino_react.common.constants.CardType;
const urlMapping = svs.core.urlMapping;
const useLiveData = svs.components.casino_react.casino_store.hooks.useLiveData;
const CasinoGamePlayers = svs.components.casino_react.casino_game_live_info.CasinoGamePlayers;
const startGameAsync = svs.components.casino.shared.startGameAsync;
const Loader = svs.components.ReactLoader.Loader;
const CasinoGamePlayTypes = svs.components.casino_react.common.constants.CasinoGamePlayTypes;
const cmsProviderList = svs.casino_react.shared.data.cmsProviderList;
const CasinoGamePreviewSimple = _ref => {
  var _cmsProviderList$find;
  let gameModel = _ref.gameModel;
  const _useLiveData = useLiveData(gameModel),
    liveData = _useLiveData.liveData;
  const _useSearchResults = useSearchResults(),
    latestSearchQuery = _useSearchResults.latestSearchQuery;
  const _useFavorites = useFavorites(),
    isFavorite = _useFavorites.isFavorite,
    toggleFavorite = _useFavorites.toggleFavorite,
    isPending = _useFavorites.isPending,
    isLoggedIn = _useFavorites.isLoggedIn;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    loadingType = _useState2[0],
    setLoadingType = _useState2[1];
  const title = gameModel.title,
    provider = gameModel.provider,
    rtp = gameModel.rtp,
    winLines = gameModel.winLines,
    freePlayAllowed = gameModel.freePlayAllowed,
    name = gameModel.name;
  const handleFavoriteClick = async () => {
    if (!isLoggedIn) {
      svs.components.customer_login.login();
      return;
    }
    await toggleFavorite(name);
  };
  const isFav = isFavorite(name);
  const providerModel = cmsProviderList === null || cmsProviderList === void 0 || (_cmsProviderList$find = cmsProviderList.find(item => item.model.provider === provider)) === null || _cmsProviderList$find === void 0 ? void 0 : _cmsProviderList$find.model;
  const providerPath = "".concat(urlMapping.get('casinoProvider'), "/").concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.systemName);
  const handleClick = async (e, playType) => {
    e.preventDefault();
    setLoadingType(playType);
    const currentIndex = '';
    if (latestSearchQuery) {
      dispatchGameToLastSearched("".concat(CardType.GAME, "_").concat(gameModel.name));
    }
    try {
      const canPlay = await startGameAsync(playType, gameModel.name, {
        name: gameModel.name,
        title: "".concat(gameModel.name, ";").concat(currentIndex),
        position: "".concat(getAnalyticsPosition({
          isSearched: Boolean(latestSearchQuery)
        }), ";").concat(gameModel.name)
      }, gameModel, Boolean(latestSearchQuery));
      if (!canPlay) {
        setLoadingType(null);
      }
    } catch (_unused) {
      setLoadingType(null);
    }
  };
  return React.createElement(CardBody, {
    className: "casino-game-preview-simple"
  }, React.createElement("div", {
    className: "casino-game-preview-simple__icons-wrapper"
  }, React.createElement("a", {
    "aria-label": "L\xE4s mer om ".concat(title),
    href: "".concat(urlMapping.get('casinoGameInfo'), "/").concat(name),
    tabIndex: -1,
    title: "L\xE4s mer om ".concat(title)
  }, React.createElement(IconButton, {
    tabIndex: -1
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: "information",
    size: "300"
  }))), React.createElement(IconButton, {
    "aria-label": isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter',
    className: "casino-game-preview-simple__favorite-button",
    disabled: isPending,
    onClick: handleFavoriteClick,
    tabIndex: -1,
    title: isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter'
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: isFav ? 'favorites-filled' : 'favorites',
    size: "300"
  }))), React.createElement("div", {
    className: "casino-game-preview-simple__title-wrapper"
  }, React.createElement("h3", {
    className: "casino-game-preview-simple__title"
  }, title), providerModel !== null && providerModel !== void 0 && providerModel.systemName ? React.createElement(Link, {
    className: "game-preview-body__provider-link",
    tabIndex: -1,
    title: "Visa spel fr\xE5n ".concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider),
    to: providerPath
  }, providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider) : React.createElement("span", null, gameModel === null || gameModel === void 0 ? void 0 : gameModel.provider)), React.createElement("ul", null, rtp > 0 && React.createElement("li", null, "RTP:", ' ', React.createElement("span", {
    className: "casino-game-preview-simple__list-text"
  }, rtp, "%")), winLines > 0 && React.createElement("li", null, "Vinstlinjer:", ' ', React.createElement("span", {
    className: "casino-game-preview-simple__list-text"
  }, winLines, ' ', "st")), React.createElement(CasinoGamePlayers, {
    gameModel: gameModel,
    liveData: liveData
  })), React.createElement("div", {
    className: "casino-game-preview-simple__button-group"
  }, freePlayAllowed && React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoDemoPlay'), "/").concat(name),
    inverted: true,
    onClick: e => handleClick(e, CasinoGamePlayTypes.demoPlay),
    tabIndex: -1,
    title: "Provspela ".concat(title),
    transparent: true,
    type: "button"
  }, loadingType === CasinoGamePlayTypes.demoPlay ? React.createElement(Loader, {
    size: 200
  }) : 'Provspela'), React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoGamePlay'), "/").concat(name),
    onClick: e => handleClick(e, CasinoGamePlayTypes.gamePlay),
    tabIndex: -1,
    title: "Spela ".concat(title),
    type: "button"
  }, loadingType === CasinoGamePlayTypes.gamePlay ? React.createElement(Loader, {
    inverted: true,
    size: 200
  }) : 'Spela')));
};
setGlobal('svs.components.casino_react.casinoGamePreviewSimple.CasinoGamePreviewSimple', CasinoGamePreviewSimple);

 })(window);